interface IAPIErrorObject {
    errorCode: number;
    errorMessage: string;
    fields?: ApiErrorField[];
}

type ApiErrorField = {
    name: string;
    message: string;
};


// disable type-checking as this service is explicitly dedicated to parsing objects of potentially unknown type
/* eslint-disable @typescript-eslint/no-explicit-any */
abstract class IErrorParsing {
    public abstract extractAPIError(extractFrom: any): IAPIErrorObject;

    public abstract extractMessage(extractFrom: any): string;
}

export { IErrorParsing, IAPIErrorObject, ApiErrorField };
